import { render, staticRenderFns } from "./marketingRadar.vue?vue&type=template&id=1b89e6a3&scoped=true&"
import script from "./marketingRadar.vue?vue&type=script&lang=js&"
export * from "./marketingRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89e6a3",
  null
  
)

export default component.exports